import { c as _c } from "react/compiler-runtime";
import { useToast } from '@common/hooks';
import { SvgPencilFill } from '@common/icon';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Base64 } from 'js-base64';
import { useEffect, useRef } from 'react';
import { AuthApi } from '@/api';
import { Image } from '@/components/client';
import { useCheckWelloApp } from '@/hooks/useCheckWelloApp';
import { MESSAGE_KEYWORD, useHandleApp } from '@/modules/wello-app';
interface ProfileImageEditProps {
  imageSrc?: string;
}
export const ProfileImageEdit = t0 => {
  const $ = _c(31);
  const {
    imageSrc
  } = t0;
  const queryClient = useQueryClient();
  const fileInputRef = useRef(null);
  const {
    toast,
    toastError
  } = useToast();
  let t1;
  if ($[0] !== toastError) {
    t1 = error => {
      toastError({
        error
      });
    };
    $[0] = toastError;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== queryClient || $[3] !== toast) {
    t2 = async () => {
      toast({
        message: "\uD504\uB85C\uD544\uC774 \uC131\uACF5\uC801\uC73C\uB85C \uC5C5\uB370\uC774\uD2B8\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
      });
      await queryClient.invalidateQueries();
    };
    $[2] = queryClient;
    $[3] = toast;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = {
      mutationFn: _temp,
      onError: t1,
      onSuccess: t2
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    mutate: uploadFileMutate
  } = useMutation(t3);
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      type: MESSAGE_KEYWORD.IMAGE
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    request,
    response
  } = useHandleApp(t4);
  const {
    isWelloApp
  } = useCheckWelloApp();
  let t5;
  if ($[9] !== isWelloApp || $[10] !== request) {
    t5 = () => {
      if (isWelloApp) {
        request();
        return;
      }
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    };
    $[9] = isWelloApp;
    $[10] = request;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handleImageClick = t5;
  const image64 = response?.data?.image;
  let t6;
  let t7;
  if ($[12] !== image64 || $[13] !== uploadFileMutate) {
    t6 = () => {
      if (!image64) {
        return;
      }
      const byteCharacters = Base64.atob(image64);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset = offset + 512, offset) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.codePointAt(i) ?? 0;
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      const blob = new Blob(byteArrays, {
        type: "image/png"
      });
      const file = new File([blob], "image.png", {
        type: "image/png"
      });
      uploadFileMutate(file);
    };
    t7 = [image64, uploadFileMutate];
    $[12] = image64;
    $[13] = uploadFileMutate;
    $[14] = t6;
    $[15] = t7;
  } else {
    t6 = $[14];
    t7 = $[15];
  }
  useEffect(t6, t7);
  let t8;
  if ($[16] !== toast || $[17] !== uploadFileMutate) {
    t8 = event => {
      if (event.target.files && event.target.files[0]) {
        const file_0 = event.target.files[0];
        if (!file_0.type.match("image.*")) {
          toast({
            message: "\uC774\uBBF8\uC9C0 \uD30C\uC77C\uB9CC \uC5C5\uB85C\uB4DC \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
            type: "fail"
          });
        } else {
          uploadFileMutate(file_0);
        }
      }
    };
    $[16] = toast;
    $[17] = uploadFileMutate;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const handleImageChange = t8;
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <legend className="sr-only">프로필 이미지 변경</legend>;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== imageSrc) {
    t10 = <Image alt={"\uD504\uB85C\uD544 \uC774\uBBF8\uC9C0"} src={imageSrc} width={160} height={160} className="size-full rounded-pill object-cover" />;
    $[20] = imageSrc;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="absolute bottom-0 right-0 flex size-20 items-center justify-center rounded-pill bg-Gray-550"><SvgPencilFill className="size-10 text-Gray-white" /></span>;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== handleImageClick || $[24] !== t10) {
    t12 = <button className="relative size-80 cursor-pointer border-none bg-Gray-white" type="button" onClick={handleImageClick}>{t10}{t11}</button>;
    $[23] = handleImageClick;
    $[24] = t10;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== handleImageChange) {
    t13 = <input ref={fileInputRef} className="sr-only" id="profileImage" type="file" onChange={handleImageChange} />;
    $[26] = handleImageChange;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t12 || $[29] !== t13) {
    t14 = <fieldset className="flex justify-center border-none">{t9}{t12}{t13}</fieldset>;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
};
function _temp(profileImage) {
  return AuthApi["post:/wello/v2/auth/member"]({
    body: {
      profileImage
    }
  });
}